import { render, staticRenderFns } from "./company_form.vue?vue&type=template&id=0cf0973b&scoped=true&lang=pug&"
import script from "./company_form.vue?vue&type=script&lang=coffee&"
export * from "./company_form.vue?vue&type=script&lang=coffee&"
import style0 from "./company_form.vue?vue&type=style&index=0&id=0cf0973b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf0973b",
  null
  
)

export default component.exports